<template>
  <v-card class="mt-2">
    <v-card-title>SJL担当者設定</v-card-title>
    <v-card-actions>
      <v-btn @click="sjlAdd">行追加</v-btn>
      <v-btn :disabled="selected.length !== 1" @click="sjlEdit">編集</v-btn>
      <v-btn :disabled="selected.length !== 1" @click="sjlRemove">{{$t('app.buttons.remove')}}</v-btn>
    </v-card-actions>
    <v-data-table
      :headers="headers"
      :items="company.accs.SJL_Director"
      :rows-per-page-items="[10]"
      class="elevation-0"
      item-key="key"
      select-all
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
        </td>
        <td>{{ company.name }}</td>
        <td>{{props.item.buName}}</td>
        <td>{{ props.item.departmentCode }}:{{ props.item.departmentName }}</td>
        <td>{{ props.item.importDirectorName }}</td>
        <td>{{props.item.promoteDirectorName }}</td>
      </template>
    </v-data-table>
    <s-j-l-dialog
      :accRepeat="accRepeatFunc('SJL_Director')"
      :companyId="company.id"
      @create="sjlCreate"
      @refresh="load"
      ref="sjl"
    ></s-j-l-dialog>
    <sjl-edit-dialog
      :accRepeat="accRepeatFunc('SJL_Director',selected[0])"
      :companyId="company.id"
      :sjl="selected[0]"
      @refresh="load"
      ref="sjlEdit"
    ></sjl-edit-dialog>
  </v-card>
</template>
<script>
import SJLDialog from './SjlDialog'
import SjlEditDialog from './SjlEditDialog'
export default {
  components: { SJLDialog, SjlEditDialog },
  props: ['company'],
  data() {
    return {
      headers: [
        { text: '海外取引先', value: 'name', sortable: false },
        { text: '事業本部', value: 'buName', sortable: false },
        { text: '事業部', value: 'departmentName', sortable: false },
        { text: 'SJL輸入営業', value: 'importDirectorName', sortable: false },
        { text: 'SJL輸入推進', value: 'promoteDirectorName', sortable: false }
      ],
      result: [],
      selected: [],
      innerResult: [],
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      innerPagination: {
        rowsPerPage: 5,
        page: 1
      },
      query: {},
      buUrl: `divisions/kv?type=BU&companyId=${this.company.id}`,
      departmentUrl: `divisions/kv?type=DEPARTMENT&companyId=${
        this.company.id
      }`,
      employeeUrl: `employees/kv?companyId=${this.company.id}`
    }
  },
  methods: {
    sjlEdit() {
      this.$refs.sjlEdit.popup(this.company.companyId, this.selected[0].id)
    },
    sjlSave() {},
    sjlAdd() {
      this.$refs.sjl.popup()
    },
    load() {
      this.selected = []
      this.blSelected = []
      this.$emit('refresh')
    },
    sjlCreate(item) {
      var data = {}
      if (item.bu != null) {
        data = { ...data, buId: item.bu.value, buName: item.bu.text }
      }
      if (item.department != null) {
        data = {
          ...data,
          departmentId: item.department.value,
          departmentName: item.department.text
        }
      }
      if (item.product != null) {
        data = {
          ...data,
          productCode: item.product.value,
          productName: item.product.text
        }
      }
      if (item.importDirector != null) {
        data = {
          ...data,
          importDirectorId: item.importDirector.value,
          importDirectorName: item.importDirector.text
        }
      }
      if (item.promoteDirector != null) {
        data = {
          ...data,
          promoteDirectorId: item.promoteDirector.value,
          promoteDirectorName: item.promoteDirector.text
        }
      }
      if (item.forwarder != null) {
        data = {
          ...data,
          partnerId: item.partner.value,
          partnerName: item.partner.text
        }
      }
      if (this.accRepeat('SJL_Director', item)) return
      this.company.accs.SJL_Director.push({
        ...data,
        key: new Date().getTime()
      })
    },
    accRepeatFunc(key, excludeItem) {
      return acc => {
        return this.accRepeat(key, acc, excludeItem)
      }
    },
    accRepeat(key, item, excludeItem) {
      function itemEqual(a, b) {
        a = a || null
        b = b || null
        return a === b
      }
      let flag =
        this.company.accs[key]
          .filter(i => (excludeItem ? i != excludeItem : true))
          .filter(i => itemEqual(i.buId, item.bu ? item.bu.value : null))
          .filter(i =>
            itemEqual(
              i.departmentId,
              item.department ? item.department.value : null
            )
          ).length > 0
      if (flag) {
        this.$message('', '重複キーを追加できません')
      }
      return flag
    },
    sjlRemove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map(s => {
              return this.$http.delete(`/companies/${s.id}/delete-sjl-acc`)
            })
          ).then(() => {
            this.selected = []
            this.$emit('refresh')
            this.$message('', '削除成功')
          })
        }
      )
    }
  },
  mounted() {
    this.load()
  }
}
</script>
